import { useQuery } from '@tanstack/react-query';
import { penaltyService } from '@/services/penalty.service';

interface UseMyPenaltiesParams {
  page?: number;
  limit?: number;
  status?: 'pending' | 'approved' | 'rejected';
  date_from?: string;
  date_to?: string;
  enabled?: boolean;
}

export function useMyPenalties(params: UseMyPenaltiesParams = {}) {
  const { enabled = true, ...queryParams } = params;
  return useQuery({
    queryKey: ['my-penalties', queryParams],
    queryFn: () => penaltyService.listMy(queryParams),
    enabled,
  });
}
